/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { getDetailQuestionsAnswered, updateDetailDateRange } from 'state/actions/detailViewState/detailViewStatus';
import { updataDetailDropDown, fetchCountries, fetchEmbeds, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';
// component
import QuestionsAnswered from 'pages/dashboard/analytics/detail/metrics/questionsanswered/questionsanswered';// component



/* ========== ~~~~~~~~~~ DATA QUESTIONS ANSWERED : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ detailViewStatus, sessionStatus, accountData }) => ({
    devices: detailViewStatus.devices,
    selectedDevices: detailViewStatus.selectedDevices,
    countries: detailViewStatus.countries,
    countriesReceived: detailViewStatus.countriesReceived,
    selectedCountries: detailViewStatus.selectedCountries,
    sites: accountData.sites,
    sitesReceived: accountData.sitesReceived,
    selectedSites: detailViewStatus.selectedSites,
    embeds: detailViewStatus.embeds,
    embedsReceived: detailViewStatus.embedsReceived,
    selectedEmbeds: detailViewStatus.selectedEmbeds,
    dateRange: detailViewStatus.dateRange,

    questionsAnsweredDetail: detailViewStatus.questionsAnsweredDetail,
    questionsAnsweredDetailFetching: detailViewStatus.questionsAnsweredDetailFetching,

    accountUUID: sessionStatus.accountUUID
    });

// map actions
const mapDispatchToProps = dispatch => ({
    displayMessage: message => dispatch(displayMessage(message)),
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    updateDetailDropDown: (items, itemType) => dispatch(updataDetailDropDown(items, itemType)),
    fetchCountries: (accountUUID, paramString) => dispatch(fetchCountries(accountUUID, paramString)),
    fetchEmbeds: (accountUUID) => dispatch(fetchEmbeds(accountUUID)),
    getDetailQuestionsAnswered: (paramString) => dispatch(getDetailQuestionsAnswered(paramString)),
    clearDetailState: () => dispatch(clearDetailState()),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionsAnswered);
